// in src/App.js
import React from 'react';
import Config from './Config'

import { Admin, Resource, ListGuesser, ShowGuesser } from 'react-admin';

import './lib/security';
import authProvider from './lib/authProvider';
import dataProvider from './lib/dataProvider';


//import { UserList } from './Users';
//import { PageList, PageEdit, PageCreate } from './Pages';
import { InvoiceList, InvoiceShow, InvoiceEdit, InvoiceCreate } from './Invoice';
import { JobList, JobShow, JobEdit, JobCreate } from './Job';
import Dashboard from './Dashboard';

import InvoiceIcon from '@material-ui/icons/Receipt';
import JobIcon from '@material-ui/icons/LocalShipping';
import TransactionIcon from '@material-ui/icons/CreditCard';

//import jsonServerProvider from 'ra-data-json-server';
//const dataProvider = jsonServerProvider('https://jsonplaceholder.typicode.com');


const App = () => (
    <Admin dashboard={Dashboard} 
        initialState={({})} 
        authProvider={authProvider(Config)} 
        dataProvider={dataProvider(Config)}
    >
        
        <Resource name="invoice" list={InvoiceList} show={InvoiceShow} icon={InvoiceIcon} sort={{ field: 'date', order: 'DESC' }}/>
        <Resource name="invoice/job" list={JobList} show={JobShow} icon={JobIcon} sort={{ field: 'date', order: 'DESC' }}/>

        <Resource name="invoice/component"/>
        <Resource name="invoice/transaction"/>
        
        {/* 
        <Resource name="transaction"
            list={TransactionList}
            show={TransactionShow}
            icon={TransactionIcon}
        />
        */}

        {/* <Resource name="pages"     icon={PostIcon} list={PageList}    edit={PageEdit}    create={PageCreate} /> */}
        {/* <Resource name="products"  icon={PostIcon} list={ListGuesser} edit={EditGuesser} create={PageCreate} /> */}
        {/* <Resource name="drivers"   icon={PostIcon} list={ListGuesser} edit={EditGuesser} create={PageCreate} /> */}
        {/* <Resource name="users"     icon={UserIcon} list={ListGuesser} edit={EditGuesser} /> */}
    </Admin>
);
export default App;


// WEBPACK FOOTER //
// ./src/App.js